import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'callouts',
    label: 'Youth Fidelity Callouts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
